module.exports = __webpack_public_path__ + "img/blog-23.a725334d.jpg";